<template>
  <div>
    <Breadtabsheader />
    <div class="h-content">
      <div class="h-piece">
        <el-form
          :inline="true"
          :model="q"
          class="demo-form-inline h-formBorder"
        >
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="用户单位">
              <el-input
                v-model="q.deptName"
                placeholder="请输入用户单位"
                :clearable="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="渠道" prop="bidChannel">
              <el-select
                  v-model="q.bidChannel"
                  clearable
                  placeholder="请选择"
                  style="width: 100%"
              >
                <el-option
                    v-for="item in qudaoList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="h-thirdColumn w-newColumn">
          </div>
        </el-form>
        <!----------------------------------- 展开搜素 ---------------------------------------------->
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="selectPageAll"
              >检索</el-button
            >
            <el-button class="h-btn h-formBtn h-bgwhite" @click="rest"
              >重置</el-button
            >
            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="createNew">
              新建
            </el-button>
          </div>
        </div>
      </div>
      <!-- 结果展示 -->
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :data="tableData"
          :border="true"
          max-height="560"
          style="width: 100%"
        >
          <el-table-column
              type="selection"
              width="55">
          </el-table-column>
          <el-table-column label="序号" type="index"  width="50">
          </el-table-column>
<!--            <el-table-column
                prop="area"
                label="区域"
                width="90"
            >
              <template scope="scope">
                  {{scope.row.area | dictname('YLRegion')}}
              </template>
            </el-table-column>
          <el-table-column
            prop="city"
            label="城市"
            width="90"
          ></el-table-column>
          <el-table-column
            prop="month"
            label="月份"
            width="90"
          ></el-table-column>-->

            <el-table-column
                prop="hangingDate"
                label="挂网日期"
                width="90"
            ></el-table-column>

          <el-table-column prop="q1Target" label="基本信息">
            <el-table-column
                prop="projectName"
                label="项目名称"
                width="90"
            ></el-table-column>


            <el-table-column prop="deptName" label="用户单位" width="140" :show-overflow-tooltip="true">
              <template scope="scope">
                <div style="text-align: left">
                  {{ scope.row.deptName }}
                </div>
              </template>
            </el-table-column>
          <el-table-column
              prop="ownerContacts"
              label="业主联系人"
              width="90"
          ></el-table-column>
            <el-table-column
                prop="ownerTelephone"
                label="业主联系电话">
            </el-table-column>

          <el-table-column
              prop="agency"
              label="代理机构">
          </el-table-column>

          <el-table-column
              prop="agencyContacts"
              label="代理机构联系人"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="agencyTelephone"
              label="代理机构联系方式"
              width="90"
          ></el-table-column>
          </el-table-column>
          <el-table-column prop="zhongbiao" label="中标信息">
          <el-table-column
              prop="bidChannel"
              label="渠道"
              width="90"
          ></el-table-column>
            <el-table-column
                prop="bidProductType"
                label="产品类别"
                width="90"
            ></el-table-column>
          <el-table-column
              prop="bidProduct"
              label="产品"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="bidNumber"
              label="数量"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="bidResult"
              label="开标结果"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="bidBrand"
              label="中标品牌"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="bidModel"
              label="中标型号"
              width="90"
          ></el-table-column>



            <el-table-column
                prop="bidCompany"
                label="中标公司"
                width="120"
            >
            </el-table-column>

            <el-table-column
                prop="bidTotal"
                label="中标总额(万元)"
                width="90"
            ></el-table-column>

          </el-table-column>

            <el-table-column prop="zhaobiao" label="招标信息">

            <el-table-column
                prop="tenderId"
                label="招标Id"
                width="90"
            ></el-table-column>
            <el-table-column
                prop="tenderProject"
                label="项目名称"
                width="90"
            ></el-table-column>
              <el-table-column
                  prop="tenderHangingDate"
                  label="挂网日期"
                  width="90"
              ></el-table-column>
            <el-table-column
                prop="tenderEndDate"
                label="截止/开标日期"
                width="90"
            ></el-table-column>
            <el-table-column
                prop="tenderSubpackage"
                label="分包"
                width="90"
            ></el-table-column>

              <el-table-column
                  prop="tenderIsPack"
                  label="是否打包"
                  width="90"
              ></el-table-column>

              <el-table-column
                  prop="tenderCreate"
                  label="扩建/新建"
                  width="90"
              ></el-table-column>

              <el-table-column
                  prop="tenderInterest"
                  label="是否贴息"
                  width="90"
              ></el-table-column>

            </el-table-column>
          <el-table-column
              label="操作"
              fixed="right"
              width="150"
          >
            <template slot-scope="scope">
                <el-button
                    type="text"
                    size="small"
                    class="h-tableLink h-btn"
                    @click="updateDetail(scope.row.id)"
                >修改</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <div class="h-tableBL">
              <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                         @click="deletebatchSingle">批量删除
              </el-button>
              <el-button
                class="h-btn h-formBtn h-bgblueQ"
                icon="h-el-icon h-el-icon-import"
                @click="exportExcelAll"
                >批量导出
              </el-button>
              <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                         @click="uploaddownexcelflagbtn">批量导入
              </el-button>
              <uploaddownexcel
                  :visible.sync="uploaddownexcelflag"
                  v-if="uploaddownexcelflag"
                  clsname="bscTopTenderMessageExcel"
                  :startrow="2" @callback="uploadExcelFilecallback"/>
            </div>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="selectPageAll" />
          </div>
          <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="updateDetailFlg" class="h-dialog2" >
            <div class="h-dialogImg">
              <div class="h-disTable">
                <div class="h-tableCell">
                  <h1>{{titleDig}}</h1>
                </div>
              </div>
            </div>
            <div class="h-formLines">
              <div style="padding: 12px;">
                <el-form :model="add" ref="add" label-position="right" :inline="true" label-width="80" :rules="editFormRules"
                         class="demo-ruleForm h-formbLine h-formbLine1">
                  <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                    <h1>基本信息</h1>
                  </div>
<!--                  <el-form-item label="年度" prop="year">
                    <el-select filterable v-model="add.year" :clearable="true"  >
                      <el-option
                          v-for="(item) in qyearList"
                          :key="item"
                          :label="item"
                          :value="item">
                      </el-option>
                    </el-select>
                  </el-form-item>-->
<!--                  <el-form-item label="区域"  prop="areaCode">
                    <brselect category="YLRegion" :v="add.area" v-model="add.area" :clearable="true"
                              @change="changeArea"
                    />
                  </el-form-item>
                  <el-form-item label="城市"  prop="city">
                    <el-select v-model="add.city" filterable clearable
                               placeholder="城市" @change="changeCity">
                      <el-option
                          v-for="item in cityList"
                          :key="item.city"
                          :label="item.city"
                          :value="item.city">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="月份"  prop="month">
                    <el-date-picker
                        v-model="add.month"
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="选择月">
                    </el-date-picker>
                  </el-form-item>-->
                  <el-form-item label="挂网日期"  prop="hangingDate">
                    <el-date-picker type="date"  value-format="yyyy-MM-dd" placeholder="选择日期" v-model="add.hangingDate" style="width: 100%;"></el-date-picker>
                  </el-form-item>

                  <el-form-item label="项目名称"  prop="maintainer">
                    <el-input v-model.trim="add.projectName" placeholder="请输入"/>
                  </el-form-item>
                  <el-form-item label="用户单位" prop="userUnitName">
                    <el-select v-model="add.deptName" remote filterable :filter-method="showGroupList" :clearable="true"
                               style="width: 140px;"
                               placeholder="请输入"
                               :remote-method="showGroupList" @change="showGroupList"  >
                      <el-option v-for="(item,index) in customerNameList"
                                 :key="index"
                                 :label="item.deptName"
                                 :value="item.deptName">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="业主联系人"  prop="ownerContacts">
                    <el-input v-model.trim="add.ownerContacts" placeholder="请输入"/>
                  </el-form-item>
                  <el-form-item label="业主联系电话"  prop="ownerTelephone">
                    <el-input v-model.trim="add.ownerTelephone" placeholder="请输入"/>
                  </el-form-item>
                  <el-form-item label="代理机构"  prop="agency">
                    <el-input v-model.trim="add.agency" placeholder="请输入"/>
                  </el-form-item>

                  <el-form-item label="代理机构联系人"  prop="agencyContacts">
                    <el-input v-model.trim="add.agencyContacts" placeholder="请输入"/>
                  </el-form-item>

                  <el-form-item label="代理机构联系方式"  prop="agencyTelephone">
                    <el-input v-model.trim="add.agencyTelephone" placeholder="请输入"/>
                  </el-form-item>
                  <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                    <h1>中标信息</h1>
                  </div>
                  <el-form-item label="渠道" prop="bidChannel">
                    <brselect category="sales_region" :v="add.bidChannel" :showcode="true"
                              v-model="add.bidChannel" filterable clearable></brselect>
                  </el-form-item>

                  <el-form-item label="产品类别"  prop="bidProductType">
                    <el-input v-model.trim="add.bidProductType" placeholder="请输入"/>
                  </el-form-item>

                  <el-form-item label="产品"  prop="bidProduct">
                    <el-input v-model.trim="add.bidProduct" placeholder="请输入"/>
                  </el-form-item>

                  <el-form-item label="数量"  prop="bidNumber">
                    <el-input v-model.trim="add.bidNumber" placeholder="请输入"/>
                  </el-form-item>
                  <el-form-item label="数量"  prop="开标结果">
                    <el-input v-model.trim="add.bidResult" placeholder="请输入"/>
                  </el-form-item>
                  <el-form-item label="中标品牌"  prop="bidBrand">
                    <el-input v-model.trim="add.bidBrand" placeholder="请输入"/>
                  </el-form-item>
                  <el-form-item label="中标型号"  prop="bidModel">
                    <el-input v-model.trim="add.bidModel" placeholder="请输入"/>
                  </el-form-item>
                  <el-form-item label="中标公司"  prop="bidCompany">
                    <el-input v-model.trim="add.bidCompany" placeholder="请输入"/>
                  </el-form-item>

                  <el-form-item label="中标总额(万元)"  prop="bidTotal">
                    <el-input v-model.trim="add.bidTotal" placeholder="请输入"/>
                  </el-form-item>
                  <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                    <h1>招标信息</h1>
                  </div>
                  <el-form-item label="招标Id"  prop="tenderId">
                    <el-input v-model.trim="add.tenderId" placeholder="请输入"/>
                  </el-form-item>
                  <el-form-item label="项目名称"  prop="tenderProject">
                    <el-input v-model.trim="add.tenderProject" placeholder="请输入"/>
                  </el-form-item>
                  <el-form-item label="挂网日期"  prop="tenderHangingDate">
                    <el-date-picker type="date"  value-format="yyyy-MM-dd" placeholder="选择日期" v-model="add.tenderHangingDate" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="截止/开标日期"  prop="tenderEndDate">
                    <el-date-picker type="date"  value-format="yyyy-MM-dd" placeholder="选择日期" v-model="add.tenderEndDate" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="分包"  prop="tenderSubpackage">
                    <el-input v-model.trim="add.tenderSubpackage" placeholder="请输入"/>
                  </el-form-item>
                  <el-form-item label="是否打包"  prop="tenderIsPack">
                    <el-input v-model.trim="add.tenderIsPack" placeholder="请输入"/>
                  </el-form-item>
                  <el-form-item label="扩建/新建"  prop="tenderCreate">
                    <el-input v-model.trim="add.tenderCreate" placeholder="请输入"/>
                  </el-form-item>
                  <el-form-item label="是否贴息"  prop="tenderInterest">
                    <el-input v-model.trim="add.tenderInterest" placeholder="请输入"/>
                  </el-form-item>
                </el-form>
              </div>
              <div style="display:flex;justify-content:center;margin-bottom:20px">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="closeDialogs">取消</el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate(1)">提交</el-button>
<!--                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitUpdate(2)">提交修改</el-button>-->
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from "../../../utils/updownfile";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

export default {
  components: {
    uploaddownexcel,
  },
  data() {
    return {
      baseClass: "active", // 基础类名
      q: {
        year: "",
        scenesCode: "",
        pageNo: 1,
        pageSize: 10,
        total: 0,
        userUnitName: "",
        agentName: "",
        province: "",
      },
      qyearList: [],
      qudaoList: [],
      tableData: [],
      cityList:[],
      //表格
      multipleSelection: [],
      customerNameList: [],
      isjlFlag: false,
      isAdmin: false,
      uploaddownexcelflag:false,
      updateDetailFlg:false,
      shenglist: [], // 省份list
      addressTypeList: [],
      monthList:["01","02","03","04","05","06","07","08","09","10","11","12"],
      runningFlag: false, // 累计跑动详情
      loudFlag: false, // 漏斗详情
      tableDatahi: [], // 跑动详情列表
      tableLoud:[],
      mf: {
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      dels:{
        id: '',
        mainId: '',
        pressDate: '',
        pressContent: '',
        pnum: '',
        cuname: '',
        ids:[],
      },
      add:{
        area:'',
        city:'',
        month:'',
        hangingDate:'',
        projectName:'',
        deptName:'',
        ownerContacts:'',
        ownerTelephone:'',
        agency:'',
        agencyContacts:'',
        agencyTelephone:'',
        bidChannel:'',
        bidProduct_type:'',
        bidProduct:'',
        bidNumber:'',
        bidResult:'',
        bidBrand:'',
        bidModel:'',
        bidCompany:'',
        bidTotal:'',
        tenderId:'',
        tenderProject:'',
        tenderHanging_date:'',
        tenderEndDate:'',
        tenderSubpackage:'',
        tenderIsPack:'',
        tenderCreate:'',
        tenderInterest:'',
      },
      editFormRules: {

      },
      titleDig:'',
      userUnitName: '',// 当前行用户名称
      channelCode: '',// 当前行用户名称
    };
  },

  methods: {
    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 列表查询
    selectPageAll() {
      ss.grabOrderApi.selectgTopTendersMessagePage(this.q).then((res) => {
        this.tableData = res.records;
        this.q.total = res.total;
      });
    },
    //导出
    exportExcelAll() {
      // 到处接口需要替换
      updownfile.down(
        "/api/swyl/v1/demo/bscTopTendersMessage/downloadExcel",
        this.q,
        "get",
        "parmea"
      );
    },
    //导入Excel
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
    },
    uploadExcelFilecallback(rd) {
      this.selectPageAll();
      this.$msg.msgs(rd.msg);
    },
    updateDetail(query){
      this.updateDetailFlg = true;
      this.titleDig = "修改"
      ss.grabOrderApi.selectByIdTopManagementUser(query).then((res) => {
        console.log(res);
        this.add = res.obj
      });

    },
    createNew(){
      this.updateDetailFlg = true;
      this.titleDig = "新建"
      this.add = {
        area:'',
        city:'',
        month:'',
        hangingDate:'',
        projectName:'',
        deptName:'',
        ownerContacts:'',
        ownerTelephone:'',
        agency:'',
        agencyContacts:'',
        agencyTelephone:'',
        bidChannel:'',
        bidProduct_type:'',
        bidProduct:'',
        bidNumber:'',
        bidResult:'',
        bidBrand:'',
        bidModel:'',
        bidCompany:'',
        bidTotal:'',
        tenderId:'',
        tenderProject:'',
        tenderHanging_date:'',
        tenderEndDate:'',
        tenderSubpackage:'',
        tenderIsPack:'',
        tenderCreate:'',
        tenderInterest:'',
      }


    },
    closeDialog(){
      this.updateDetailFlg = false;
    },
    closeDialogs(){
      this.updateDetailFlg = false;
          //重新打开弹出窗，刷新校验
          this.selectPageAll();
      this.$refs.add.resetFields();
    },

    commitCreate(query){
      ss.grabOrderApi.saveOrUpdateTopManagementUser(this.add).then((res) => {
        if(res.f){
          this.updateDetailFlg = false;
          this.selectPageAll();
        }
      });
    },
    commitUpdate(query){
      ss.grabOrderApi.saveOrUpdateTopManagementUser(this.add).then((res) => {
        if(res.f){
          this.updateDetailFlg = false;
          this.selectPageAll();
        }
      });
    },
    deletebatchSingle(){
      if (this.multipleSelection.length == 0 || this.multipleSelection == null){
        this.$message.error("没有选中可以删除的!");
        return false;
      }
      this.dels.ids = [];
      this.multipleSelection.forEach(element => {
        this.dels.ids.push(element.id);
      });
      var data = {
        ids:this.dels.ids,
      }
      this.$confirm('确定要删除数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ss.grabOrderApi.deletebatchById(data).then(res => {
          console.log(res)
          if(res.f == true ){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.selectPageAll()
          }else{
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },

    //获取用户单位
    showGroupList(value) {
      if(value == "" ){
        return;
      }
      ss.MuBiao.getUserLoud(value).then(res => {
        console.log(res);
        this.customerNameList = res
        this.add.customerCode = res[0].deptId
        this.add.bscAddressDataId = res[0].id
      })
    },
    changeArea(value){
      if(value != null && value != ''){
        console.log(value.name,"name");
        ss.customer.getAreaCity(value.name).then(rd => {
          console.log(rd);
          this.cityList = rd;
        })
      }else {
        this.cityList = [];
      }
      this.add.city = '';
    },
    changeCity(value){
      console.log(value,"name");
      this.add.city = value
      //进行强制数据渲染
      this.$forceUpdate();
    },
    // 重置
    rest() {
      var pageSize = this.q.pageSize;
      var pageNo = this.q.pageNo;
      var total = this.q.total;
      this.q = {
        pageSize: pageSize,
        pageNo: pageNo,
        total: total,
        year: "",
        scenesCode: "",
        userUnitName: "",
        agentName: "",
        province: "",
      };
    },
    loadArea(i) {
      let proSelect = {
        pcode: 0,
        level: 1,
      };
      ss.Dictservice.arealist(proSelect).then((rd) => {
        this.shenglist = rd;
      });
    },
    // 获取渠道
    getQudaoList() {
      ss.Dictservice.listbycategory("sales_region").then((rd) => {
        this.qudaoList = rd;
      });
    },
  },
  created() {
    this.selectPageAll();
    this.getQudaoList();
    for (var i = 2024; i <= new Date().getFullYear() + 30; i++) {
      this.qyearList.push(i);
    }
    this.loadArea();
    this.q.year =new Date().getFullYear();
    //this.q.month =  (new Date().getMonth()+1<10?"0"+(new Date().getMonth()+1):(new Date().getMonth()+1));// 年月
    this.isjlFlag = this.$store.getters.hasRole("swyl_quyujl,swyl_daqujl");
    this.isAdmin = this.$store.getters.hasRole("swyl_admin");
  },
};
</script>
<style scoped lang="less">
/deep/ .h-formbLine .el-form-item__label {
  width: 100px;
}
/deep/ .h-formbLine .el-form-item__content {
  width: 150px;
}
.active {
  color: red;
}
</style>
